import { fetcher } from '@/src/general/utilities/fetcher'
import type { TSignalConfig } from '@/src/general/utilities/fetcher/IFetcher'

import type { TFeedItemApi } from './feedApi.types'

export const feedApi = {
  /**
   * timestamp param has to be the same all along the pagination process
   * otherwise it could lead to potential Issues
   * - Inconsistent Data
   * - Missing Items
   * - Duplicated Items
   * - Pagination Gaps
   **/
  getFeed: async (
    { limit = 10, offset = 0, timestamp }: { limit: number; offset: number; timestamp: number | undefined },
    { signal }: TSignalConfig,
  ) => {
    const req = await fetcher.query<TFeedItemApi[]>('/feed', {
      signal,
      params: {
        limit,
        offset,
        timestamp,
      },
      headers: { 'Cache-Control': 'no-cache' },
    })

    return req
  },
}
